// Libraries
var React = require('react');
var $ = require('jquery');
var map = require('lodash/map');
var dateFormat = require('dateformat');

// Styles
require('./NewsNowModule.scss');

// Assets
var diamondIcon = require('images/diamond.svg');
var PlaceholderImg = require('images/blankImgPlaceholder.png');

class TrendingGridModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			updateUrl: this.props.data.updateUrl,
			groups: this.groupNews(this.props.data.newsArticles),
			modules: this.props.data.modules
		};
	};

	groupNews(linksList) {
		let publishDate;
		let currentTime = Date.now();

		// We define the beginning of the day,
		// to calculate the posts from yesterday and earlier today.
		let beginningOfTheDay = new Date(currentTime);
		beginningOfTheDay.setHours(0);
		beginningOfTheDay.setMinutes(0);
		beginningOfTheDay.setSeconds(0);
		beginningOfTheDay.setMilliseconds(0);

		return linksList.reduce((groups, link) => {

			publishDate = (new Date(link.publishDate)).getTime();

			if (publishDate > currentTime - 5 * 60 * 1000) {
				groups["up_to_5_mins"].links.push(link);
			}

			else if (publishDate > currentTime - 15 * 60 * 1000) {
				groups["up_to_15_mins"].links.push(link);
			}

			else if (publishDate > currentTime - 30 * 60 * 1000) {
				groups["up_to_30_mins"].links.push(link);
			}

			else if (publishDate > currentTime - 60 * 60 * 1000) {
				groups["up_to_1_hour"].links.push(link);
			}

			else if (publishDate > currentTime - 2 * 60 * 60 * 1000) {
				groups["up_to_2_hours"].links.push(link);
			}

			else if (publishDate > currentTime - 4 * 60 * 60 * 1000) {
				groups["up_to_4_hours"].links.push(link);
			}

			else if (publishDate > currentTime - 6 * 60 * 60 * 1000) {
				groups["up_to_6_hours"].links.push(link);
			}

			else if (publishDate > currentTime - 8 * 60 * 60 * 1000) {
				groups["up_to_8_hours"].links.push(link);
			}

			else if (publishDate > beginningOfTheDay.getTime()) {
				groups["earlier_today"].links.push(link);
			}

			else {
				groups["yesterday"].links.push(link);
			}

			return groups;

		}, {
			"up_to_5_mins": {
				"title": "NEW in the last 5 minutes",
				"links": []
			},
			"up_to_15_mins": {
				"title": "5 to 15 minutes old",
				"links": []
			},
			"up_to_30_mins": {
				"title": "15 to 30 minutes old",
				"links": []
			},
			"up_to_1_hour": {
				"title": "30 minutes to 1 hour old",
				"links": []
			},
			"up_to_2_hours": {
				"title": "1 to 2 hours old",
				"links": []
			},
			"up_to_4_hours": {
				"title": "2 to 4 hours old",
				"links": []
			},
			"up_to_6_hours": {
				"title": "4 to 6 hours old",
				"links": []
			},
			"up_to_8_hours": {
				"title": "6 to 8 hours old",
				"links": []
			},
			"earlier_today": {
				"title": "Earlier Today",
				"links": []
			},
			"yesterday": {
				"title": "Yesterday",
				"links": []
			}
		});
	};

	componentDidMount() {
		// Update the news every 5 minutes.
		setInterval(() => {
			$.ajax({
				url: this.state.updateUrl,
			}).done(data => {
				this.setState({
					updateUrl: data.updateUrl,
					groups: this.groupNews(data.newsArticles)
				}, window.LazyLoad.concat);
			});
		}, 60 * 5 * 1000);
	}

	render() {
		let currentGroup = 1;
		return (
			<div className="NewsNow">
				{map(this.state.groups, (group, name) => {
					if(group.links.length > 0) {
						let injectModule = this.state.modules.filter(x => x.groupPosition === currentGroup);
						currentGroup++;
						return(
							<div key={name}>
								<div className="NewsNow__container">
									<div className="NewsNow__group">
										<h3>{group.title}</h3>
										{group.links.map((link, index) => {
											return (
												<div className="NewsNow__link" key={index}>
													<div className="NewsNow__flag"><img src={PlaceholderImg} data-src={link.countryIso.length ? this.props.data.baseUrl + "/static/media/flags/4x3/" + link.countryIso + ".svg" : diamondIcon} alt={link.countryIso} /></div><div className="NewsNow__link__text"><a href={link.link} aria-label={link.title} target={"blank"} rel={"noreferrer noopener"}>{link.title}</a><span>{link.source} {dateFormat(link.publishDate, "HH:MM:ss")}</span></div>
												</div>
											)
										})}
									</div>
								</div>
								{injectModule &&
										injectModule.map((inject, index) => (
											React.createElement(window.Components[inject.name], {"data": inject.data, "key": index})
										))
								}
							</div>
						)
					}
				})}
				{this.state.modules.map((inlineModule, index) => {
					return(inlineModule.groupPosition >= currentGroup && React.createElement(window.Components[inlineModule.name], {"key": index, "data": inlineModule.data}))
				})}
			</div>
		)
	}
}

module.exports = TrendingGridModule;



// WEBPACK FOOTER //
// ./src/components/NewsNow/NewsNowModule.js